// @flow
import { APICore } from './apiCore';

const api = new APICore();

function ApiGetAllCompany(params: any): any {
    const baseUrl = '/api/admin/company';
    return api.get(`${baseUrl}`, params);
}
function ApiPostCompany(params: any): any {
    const baseUrl = '/api/admin/create_company';
    // console.log('🚀 ~ ApiPostFasilitas ~ params:', params);
    return api.create(`${baseUrl}`, params);
}
// function ApiEditPasswordPegawai(params: any, id: any): any {
//     const baseUrl = '/api/admin/department/' + id;
//     return api.update(`${baseUrl}`, params);
// }

export { ApiGetAllCompany, ApiPostCompany };
